function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M22.8,45.6c0,0.3-0.1,0.5-0.3,0.8l-10.1,10c-0.2,0.2-0.5,0.3-0.7,0.3c-0.3,0-0.5-0.1-0.7-0.3L0.8,46.3 c-0.3-0.3-0.4-0.7-0.2-1.1c0.2-0.4,0.5-0.6,0.9-0.6h6.1V1c0-0.3,0.1-0.5,0.3-0.7S8.3,0,8.6,0h6.1c0.3,0,0.5,0.1,0.7,0.3 s0.3,0.4,0.3,0.7v43.5h6.1c0.3,0,0.5,0.1,0.7,0.3S22.8,45.3,22.8,45.6z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M55.9,7.8c-0.2,0.2-0.4,0.3-0.7,0.3H28.9c-0.3,0-0.5-0.1-0.7-0.3c-0.2-0.2-0.3-0.4-0.3-0.7V1c0-0.3,0.1-0.5,0.3-0.7 C28.3,0.1,28.6,0,28.9,0h26.3c0.3,0,0.5,0.1,0.7,0.3s0.3,0.4,0.3,0.7v6.1C56.2,7.4,56.1,7.6,55.9,7.8z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M49.8,24c-0.2,0.2-0.4,0.3-0.7,0.3H28.9c-0.3,0-0.5-0.1-0.7-0.3c-0.2-0.2-0.3-0.4-0.3-0.7v-6.1c0-0.3,0.1-0.5,0.3-0.7 c0.2-0.2,0.4-0.3,0.7-0.3h20.2c0.3,0,0.5,0.1,0.7,0.3c0.2,0.2,0.3,0.4,0.3,0.7v6.1C50.1,23.6,50,23.8,49.8,24z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M43.8,40.2c-0.2,0.2-0.4,0.3-0.7,0.3H28.9c-0.3,0-0.5-0.1-0.7-0.3s-0.3-0.4-0.3-0.7v-6.1c0-0.3,0.1-0.5,0.3-0.7 c0.2-0.2,0.4-0.3,0.7-0.3H43c0.3,0,0.5,0.1,0.7,0.3s0.3,0.4,0.3,0.7v6.1C44.1,39.8,44,40,43.8,40.2z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M37.7,56.4c-0.2,0.2-0.4,0.3-0.7,0.3h-8.1c-0.3,0-0.5-0.1-0.7-0.3s-0.3-0.4-0.3-0.7v-6.1c0-0.3,0.1-0.5,0.3-0.7 c0.2-0.2,0.4-0.3,0.7-0.3H37c0.3,0,0.5,0.1,0.7,0.3s0.3,0.4,0.3,0.7v6.1C38,56,37.9,56.2,37.7,56.4z"
});

var SvgSortDesc = function SvgSortDesc(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 56.7 56.7",
    style: {
      enableBackground: "new 0 0 56.7 56.7"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSortDesc, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sort-desc.4050ae8b.svg";
export { ForwardRef as ReactComponent };